import { useMutation } from '@tanstack/react-query';

import { DocumentsApi } from 'api';
import { useFiInternalDocumentsCache } from 'tanstack-hooks/fi-internal-crb-documents/internal-crb-documents-cache';
import { BANK_DISPENSARY_INTERNAL_DOCUMENTS_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useDeleteInternalDocument(dispensaryId: string) {
  const { userBankId } = useUser();
  const documentsApi = new DocumentsApi();
  const { removeDocumentsFromCache } = useFiInternalDocumentsCache(dispensaryId);

  const {
    mutate: deleteInternalDocument,
    isPending: isDeletingInternalDocument,
    variables
  } = useMutation({
    mutationKey: [BANK_DISPENSARY_INTERNAL_DOCUMENTS_KEY, dispensaryId],
    mutationFn: ({ docIds }: { docIds: string[] }) =>
      documentsApi.fiDeleteCrbInternalDocuments(userBankId, dispensaryId, docIds),
    onSuccess: (_data, { docIds }) => removeDocumentsFromCache(docIds),
    meta: {
      snackbarErrorMessage: 'There was an issue deleting the document.'
    }
  });
  return {
    deleteInternalDocument,
    isDeletingInternalDocument,
    deletingDocIds: isDeletingInternalDocument ? variables?.docIds : undefined
  };
}
